import { useState } from "react"
import CircularProgress from '@mui/material/CircularProgress';
import { Form as FormikForm, useFormikContext } from "formik";
import StarIcon from '@mui/icons-material/Star';
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import dayjs from "dayjs";
import { Grid, TextField, Button, MenuItem, Rating, Typography, FormGroup, FormControlLabel, Checkbox } from "@mui/material";

import { CustomField } from '../../../inputs/CustomField';



export const ReviewTicketForm = ({ ticket }) => {

    const { values, setFieldValue, isSubmitting } = useFormikContext();
    const [hover, setHover] = useState(-1);
    const [hover1, setHover1] = useState(-1);

    const labels = {
        1: 'Deficiente',
        2: 'Regular',
        3: 'Aceptable',
        4: 'Bueno',
        5: 'Excelente',
    };

    const getLabelText = (value) => {
        return `${value} Star${value !== 1 ? 's' : ''}, ${labels[value]}`;
    }


    return (
        <FormikForm>
            <>
                <Grid container spacing={2} >

                    <Grid item xs={12}>

                        <Typography variant="h6" sx={{ marginLeft: "auto", marginRight: "auto" }}>
                            Con esta encuesta deseamos evaluar el nivel de satisfacción de los servicios ofrecidos.
                        </Typography>

                        <br />

                        <Typography  >
                            Técnico: <span style={{ fontWeight: "bold" }}>{`${ticket.support_assigned.displayName}`}</span>
                        </Typography>

                        <Typography >
                            Fecha :  <span style={{ fontWeight: "bold" }}>{dayjs(ticket.created_date).format('DD/MM/YYYY hh:mm A')}</span>
                        </Typography>

                        <Typography >
                            Problemática :  <span style={{ fontWeight: "bold" }}>{ticket.support_subtype_1.displayName}</span>
                        </Typography>
                    </Grid>

                    <Grid item xs={12}>
                        <Typography>¿El problema que presentaste fue resuelto?</Typography>

                        <FormGroup>
                            <FormControlLabel control={<Checkbox value={values?.succes_support === "Si" ? true : false} checked={values?.succes_support === "Si"}
                                onChange={(e) => {
                                    setFieldValue("succes_support", Boolean(e.target.checked) === true ? "Si" : "No")
                                }} />} label="Si" />

                            <FormControlLabel control={<Checkbox value={values?.succes_support === "No" ? true : false} checked={values?.succes_support === "No"}
                                onChange={(e) => {
                                    setFieldValue("succes_support", Boolean(e.target.checked) === true ? "No" : "Si")
                                }} />} label="No" />

                        </FormGroup>
                    </Grid>

                    {

                        values?.succes_support === "No" &&
                        <Grid item xs={12}>
                            <Typography>Por favor indique el porque.</Typography>
                            <CustomField name="not_success_support_comment" multiline rows={3} fullWidth as={TextField} />
                            {
                                values?.not_success_support_comment === "" &&
                                <span style={{ color: "red", fontSize: "15px" }} ><ReportProblemIcon style={{ fontSize: '13px', marginRight: "3px", marginTop: "3px" }} />Por favor completar este campo.</span>
                            }
                        </Grid>
                    }


                    <Grid item xs={12}>
                        <Typography>¿Sentiste que nuestro equipo respondió con prontitud tu solicitud?</Typography>

                        <FormGroup>
                            <FormControlLabel control={<Checkbox value={values?.support_fast_response === "Si" ? true : false} checked={values?.support_fast_response === "Si"}
                                onChange={(e) => {
                                    setFieldValue("support_fast_response", Boolean(e.target.checked) === true ? "Si" : "No")
                                }} />} label="Si" />

                            <FormControlLabel control={<Checkbox value={values?.support_fast_response === "No" ? true : false} checked={values?.support_fast_response === "No"}
                                onChange={(e) => {
                                    setFieldValue("support_fast_response", Boolean(e.target.checked) === true ? "No" : "Si")
                                }} />} label="No" />

                        </FormGroup>
                    </Grid>


                    <Grid item xs={12}>
                        <Typography>¿Cómo calificarías la cordialidad del soporte técnico?</Typography>
                        <Rating
                            size="large"
                            sx={{ marginTop: 2 }}
                            name="hover-feedback"
                            value={values?.politely_support || 0}
                            precision={1}
                            getLabelText={getLabelText}
                            onChange={(event, newValue) => {
                                setFieldValue("politely_support", newValue)
                            }}
                            onChangeActive={(event, newHover) => {
                                setHover(newHover);
                            }}
                            emptyIcon={<StarIcon style={{ opacity: 0.55 }} fontSize="inherit" />}
                        />

                        <Typography sx={{ fontWeight: "bold", marginTop: "10px", marginLeft: 1 }}>{labels[hover !== -1 ? hover : (values?.politely_support || 0)]}</Typography>
                        {
                            (values?.politely_support < 1 || !values.politely_support) &&
                            <span style={{ color: "red", fontSize: "15px" }} ><ReportProblemIcon style={{ fontSize: '13px', marginRight: "3px", marginTop: "3px" }} />Por favor completar este campo.</span>
                        }
                    </Grid>

                    <Grid item xs={12}>
                        <Typography>¿Qué tan satisfecho estás con el soporte brindado?</Typography>
                        <Rating
                            size="large"
                            sx={{ marginTop: 2 }}
                            name="hover-feedback"
                            value={values?.pleasure_support || 0}
                            precision={1}
                            getLabelText={getLabelText}
                            onChange={(event, newValue) => {
                                setFieldValue("pleasure_support", newValue)
                            }}
                            onChangeActive={(event, newHover) => {
                                setHover1(newHover);
                            }}
                            emptyIcon={<StarIcon style={{ opacity: 0.55 }} fontSize="inherit" />}
                        />

                        <Typography sx={{ fontWeight: "bold", marginTop: "10px", marginLeft: 1 }}>{labels[hover1 !== -1 ? hover1 : (values?.pleasure_support || 0)]}</Typography>
                        {
                            (values?.pleasure_support < 1 || !values.pleasure_support) &&
                            <span style={{ color: "red", fontSize: "15px" }} ><ReportProblemIcon style={{ fontSize: '13px', marginRight: "3px", marginTop: "3px" }} />Por favor completar este campo.</span>
                        }
                    </Grid>

                    <Grid item xs={12}>
                        <Typography>¿Hay algo en lo que podríamos mejorar para brindarte un mejor servicio en el futuro?</Typography>
                        <CustomField name="comment" multiline rows={2} fullWidth as={TextField} />
                    </Grid>


                    <Grid item sm={12} mt={3}>
                        <Button
                            variant="contained"
                            type="submit"
                            disabled={(values.succes_support === "No" && !values.not_success_support_comment)}
                            fullWidth
                        >
                            {isSubmitting && <CircularProgress size={"15px"} sx={{ color: "white" }} />}
                            {isSubmitting ? 'Enviando' : 'Enviar'}
                        </Button>
                    </Grid>



                </Grid>


            </>
        </FormikForm>

    );
}

export default ReviewTicketForm;